<!-- 地图 -->
<template>
  <div class="h-map">
    <ve-map
      class="echarts-map"
      :data="chartData"
      :settings="chartSettings"
      height="600px"
      width="600px"
      :extend="chartExtend"
    ></ve-map>
  </div>
</template>

<script>
export default {
  data () {
    return {
      chartSettings: {
        position: 'china',
        metrics: ['门店数'],
        itemStyle: {
          normal: {
            borderColor: '#72F2FF',
            areaColor: '#7F8FA3',
            borderWidth: 2,
            shadowBlur: 1
          },
          emphasis: {
            borderColor: '#72F2FF',
            areaColor: '#19355A',
            borderWidth: 1,
            shadowBlur: 1
          }
        },
        label: {
          normal: {
            show: true,
            formatter: function (params) {
              if (params.value) {
                return params.name + ' ' + params.value // 地图上展示文字 + 数值
              } else {
                return ''
              }
            },
            color: '#fff',
            backgroundColor: 'rgba(0, 15, 42, 0.3)',
            fontSize: 12,
            align: 'right',
            verticalAlign: 'top',
            lineHeight: 12,
            padding: 4,
            borderRadius: 4
          },
          emphasis: {
            show: true,
            formatter: function (params) {
              if (params.value) {
                return params.name + ' ' + params.value // 地图上展示文字 + 数值
              } else {
                return ''
              }
            },
            color: '#44F0FF'
          }
        },
        selectData: true,
        scaleLimit: {
          min: 1,
          max: 2
        },
        roam: true
      },
      chartExtend: {
        legend: {
          show: false
        },
        visualMap: [
          {
            // type: 'continuous',
            // textStyle: {
            //   color: '#fff'
            // },
            // top: 'bottom',
            left: 'right',
            calculable: true,
            inRange: {
              color: ['#4C627F', '#99A5B6', '#334C6D', '#19355A', '#001F48']
            },
            text: ['High', 'Low'], // 文本，默认为数值文本
            show: false,
            splitList: null
          }
        ],
        series: {
          data: null // 各省地图颜色数据依赖value
        }
      }
    }
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  watch: {
    chartData: {
      handler (newVal, oldVal) {
        this.chartExtend.series.data = this.getDataList(newVal.rows)
        this.chartExtend.visualMap[0].splitList = this.getSplitList(newVal.rows)
      },
      deep: true
    }
  },
  methods: {
    getDataList (arr) {
      let tempArr = []
      arr.forEach(item => {
        const flag = false
        tempArr.push({
          name: item.name,
          selected: flag,
          value: item['门店数']
        })
      })
      return tempArr
    },
    getSplitList (arr) {
      let tempArr = []
      arr.forEach(item => {
        tempArr.push({
          label: item.name,
          start: item['门店数'],
          end: item['门店数']
        })
      })
      return tempArr
    }
  }
}
</script>

<style lang='stylus' scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/hMap.vue